
import './styles.css';
import { useHistory } from "react-router-dom";

// import { ShowLoading } from '../../component/loading-bootstrap';

function Main() {
    
    const history = useHistory();
    
    return (
        <div className='content'>

            <div className="content-menu" >
                <div className="box-menu" onClick={ () => { history.push({ pathname: "/d-rec-admin/main/production" });} }>
                    <div className="content" style={{ backgroundColor: "rgb(242, 123, 129)" }}>
                        <div className="shot-name">PD</div>
                        <div className="full-name">Production</div>
                        <div className="line"></div>
                        <div className="note">All about Production</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => { history.push({ pathname: "/d-rec-admin/main/maintenance" });} }>
                    <div className="content" style={{ backgroundColor: "rgb(242 238 123)" }}>
                        <div className="shot-name">MT</div>
                        <div className="full-name">Maintenance</div>
                        <div className="line"></div>
                        <div className="note">All about Maintenance</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/enquipment" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(198, 156, 237)" }}>
                        <div className="shot-name">TE</div>
                        <div className="full-name">Manage Equipment</div>
                        <div className="line"></div>
                        <div className="note">For View TAG/Equipment</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/settings" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(147, 221, 195)" }}>
                        <div className="shot-name">ST</div>
                        <div className="full-name">Setting</div>
                        <div className="line"></div>
                        <div className="note">For Setting Application</div>
                    </div>
                </div>
            </div>
            
        </div >);
}

export default Main;